import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { SelectUnit, SelectUnitRow } from './types'
import {
  SELECT_UNIT_ROW_0,
  SELECT_UNIT_ROW_1,
  SELECT_UNIT_ROW_2,
  SELECT_UNIT_ROW_3,
  SELECT_UNIT_ROW_4,
} from './data'

export interface ISelectUnitsState {
  selectedUnits: SelectUnit[]
  selectedIndividualUnits: SelectUnit[]
  units: SelectUnit[]
  unitsClimate: SelectUnit[]
  unitsCovered: SelectUnit[]
  row0: SelectUnitRow[]
  row1: SelectUnitRow[]
  row2: SelectUnitRow[]
  row3: SelectUnitRow[]
  row4: SelectUnitRow[]
}

const initialState: ISelectUnitsState = {
  selectedUnits: [],
  selectedIndividualUnits: [],
  units: [],
  unitsClimate: [],
  unitsCovered: [],
  row0: SELECT_UNIT_ROW_0,
  row1: SELECT_UNIT_ROW_1,
  row2: SELECT_UNIT_ROW_2,
  row3: SELECT_UNIT_ROW_3,
  row4: SELECT_UNIT_ROW_4,
}

export const slice = createSlice({
  name: 'selectUnits',
  initialState,
  reducers: {
    onSelectedUnits: (
      state: ISelectUnitsState,
      action: PayloadAction<typeof initialState.selectedUnits>
    ) => {
      state.selectedUnits = action.payload
    },
    onSelectedIndividualUnits: (
      state: ISelectUnitsState,
      action: PayloadAction<typeof initialState.selectedIndividualUnits>
    ) => {
      state.selectedIndividualUnits = action.payload
    },
    onAllUnits: (
      state: ISelectUnitsState,
      action: PayloadAction<{
        units: typeof initialState.units
        unitsClimate: typeof initialState.unitsClimate
        unitsCovered: typeof initialState.unitsCovered
      }>
    ) => {
      state.units = action.payload.units
      state.unitsClimate = action.payload.unitsClimate
      state.unitsCovered = action.payload.unitsCovered
    },
    onAllRows: (
      state: ISelectUnitsState,
      action: PayloadAction<{
        row0: typeof initialState.row0
        row1: typeof initialState.row1
        row2: typeof initialState.row2
        row3: typeof initialState.row3
        row4: typeof initialState.row4
      }>
    ) => {
      state.row0 = action.payload.row0
      state.row1 = action.payload.row1
      state.row2 = action.payload.row2
      state.row3 = action.payload.row3
      state.row4 = action.payload.row4
    },
    onResetSelected: (state: ISelectUnitsState) => {
      state.row0 = SELECT_UNIT_ROW_0
      state.row1 = SELECT_UNIT_ROW_1
      state.row2 = SELECT_UNIT_ROW_2
      state.row3 = SELECT_UNIT_ROW_3
      state.row4 = SELECT_UNIT_ROW_4
      state.selectedUnits = []
    },
    onResetState: (state: ISelectUnitsState) => {
      state.row0 = SELECT_UNIT_ROW_0
      state.row1 = SELECT_UNIT_ROW_1
      state.row2 = SELECT_UNIT_ROW_2
      state.row3 = SELECT_UNIT_ROW_3
      state.row4 = SELECT_UNIT_ROW_4
      state.selectedIndividualUnits = []
      state.selectedUnits = []
      state.units = []
      state.unitsClimate = []
      state.unitsCovered = []
    },
  },
})

export const { actions, reducer } = slice

export type ISelectUnits = {
  selectUnits: ISelectUnitsState
}
